import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepConnector from "@material-ui/core/StepConnector";
import SimObat from "../../../components/Icons/simobat.png";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  iconContainer: {
    "& svg": {
      width: 32,
      height: 32,
    },
  },
}));

const ColorlibConnector = withStyles({
  active: {
    "& $line": {
      backgroundColor: "#4D53E0",
    },
  },
  completed: {
    "& $line": {
      backgroundColor: "#4D53E0",
    },
  },
  line: {
    border: 0,
    width: 3,
    backgroundColor: "#4D53E0",
    borderRadius: 0,
  },
  vertical: {
    padding: 0,
    marginLeft: 14,
    marginTop: -8,
    marginBottom: -8,
    "& span": {
      minHeight: 40,
    },
  },
})(StepConnector);

export default function TasksStepper({ pageUsage = [] }) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleClick = (e) => {
    setActiveStep(e);
  };

  // Format tanggal untuk last_access
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("id-ID", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  // Ambil top 6 page usage
  const topPages = pageUsage.slice(0, 6);

  return (
    <div className={classes.root}>
      {topPages.length > 0 ? (
        <Stepper
          activeStep={activeStep}
          orientation="vertical"
          connector={<ColorlibConnector />}
        >
          {topPages.map((item, index) => (
            <Step key={index} onClick={() => handleClick(index)}>
              <StepLabel className={classes.iconContainer}>
                <div
                  key={index}
                  className="d-flex flex-row align-self-baseline ml-3"
                >
                  <img
                    src={SimObat}
                    alt="page icon"
                    style={{ width: 32, height: 32 }}
                  />
                  <div className="d-flex flex-column ml-3">
                    <p className="body-2">{item.page}</p>
                    <p className="body-3 muted">
                      {item.total_akses} akses - {formatDate(item.last_access)}
                    </p>
                  </div>
                </div>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      ) : (
        <div className="text-center py-4">Tidak ada data pemanfaatan</div>
      )}
    </div>
  );
}
